import React, { useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";

  const Banner = () => {

    const [type, setType] = useState("");
    let publicUrl = process.env.PUBLIC_URL + "/";
    const locations = [
      { value: 1, label: "Delhi" },
      { value: 2, label: "Gurgaon" },
      { value: 3, label: "Noida" },
      { value: 4, label: "Faridabad" },
    ];

    const price = [
      { value: 1, label: "Rs.(0.5-1.0) Crore" },
      { value: 2, label: "Rs.(1.0-1.5) Crore" },
      { value: 3, label: "Rs.(1.5-2.0) Crore" },
      { value: 4, label: "Above 2 crore" },
    ];
    
    const types = [
      { value: 1, label: "Apartment" },
      { value: 2, label: "Land" },
      { value: 3, label: "Commercial" },
      { value: 4, label: "Villas" },
    ];

    const handleLocationChange = (selectedOption) => {
      // Handle location change
      console.log(selectedOption);
    };

    
    return (
      <div
        className="banner-area banner-area-1 banner-area-bg"
        style={{ background: "url(" + publicUrl + "assets/img/banner/1.png)" }}
      >
        <div className="container">
          <div className="banner-area-inner">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <div className="banner-inner text-center">
                  <p>
                    Lorem ipsum dolor sit amet, consecteLorem ipsum dolor sit
                    amet,
                  </p>
                  <div className="line" />
                  <h2>The Best Way To Find Your Perfect Home</h2>
                </div>
              </div>
              <div className="col-lg-8 mt-4">
                <form className="main-search-inner">
                  <div className="row custom-gutters-10">
                    <div className="col-md-3">
                      <div className="single-select-inner">
                        <Select
                          id="location"
                          options={locations}
                          placeholder="Location"
                          isSearchable
                          onChange={handleLocationChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="single-select-inner">
                        <select id="type" value={type} onChange={(e) => {setType(e.target.value);console.log(e.target.value)}}>
                          <option value={0}>Type</option>
                          {types.map((type) => (
                            <option key={type.label} value={type.label}>
                              {type.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  
                    {type === "Apartment" && (
                      <div className="col-md-3">
                        <div className="single-select-inner">
                          <select defaultValue={0}>
                            <option value={0}>Subtype</option>
                            <option value={1}>1 bedroom</option>
                            <option value={2}>2 bedroom</option>
                            <option value={3}>3 bedroom</option>
                          </select>
                        </div>
                      </div>
                    )}
              
                    <div className="col-md-3">
                      <div className="single-select-inner">
                        <select defaultValue={0}>
                          <option value={0}>Price</option>
                          {price.map((p) => (
                            <option key={p.value} value={p.value}>
                              {p.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <Link
                        className="btn btn-base w-100"
                        to="/property-for-sale"
                      >
                        <i className="fa fa-search mr-1" /> Search
                      </Link>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };


export default Banner;
